import { Dispatch } from 'react';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';
import { ContentListAction } from '../model';

interface Props {
	selectedContentIds: number[];
	dispatch: Dispatch<ContentListAction>;
	closeEditMode: () => void;
}

export function ContentListDeletePopup({ selectedContentIds, dispatch, closeEditMode }: Props) {
	const { popLayer } = useUILayerStore();

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<InformationPopup.TextContainer>
				<InformationPopup.Title>
					{selectedContentIds.length}
					개의 콘텐츠를
					<br />
					삭제하시겠어요?
				</InformationPopup.Title>
				<InformationPopup.Warning>삭제하면 다시 복구할 수 없어요.</InformationPopup.Warning>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					아니요
				</InformationPopup.Button>
				<InformationPopup.Button
					type="confirm"
					onClick={() => {
						dispatch({
							type: 'DELETE_CONTENTS',
						});
						popLayer();
						closeEditMode();
					}}
				>
					네, 삭제할게요
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
